import React from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  FetchFaqsList,
  getFaqsCategoryData,
  DeleteFaqsRecord,
} from "../../services/Service";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import { toast } from "react-toastify";
import { getCompanyTimezoneDateTime } from "helpers/utils";

function FaqsList(props) {
  const [faqsData, setFaqsData] = useState([]);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [categories, setCategories] = useState("");

  // Fetch Faqs listing data
  useEffect(() => {
    FetchFaqsList()
      .then(res => {
        console.log("24:responsedata", res.data.faqsList);
        if (res.data.success) {
          // console.log('FetchFaqsList:::27',res.data.data)
          setFaqsData(res.data.faqsList);
        }
      })
      .catch(err => {
        toast.error("No data Available");
      });
  }, []);
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
  // Bootstrap table columns
  const columns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
    },
    {
      dataField: "faqs_category.name",
      text: "Category",
    },
    {
      dataField: "question",
      text: "Question",
    },
    {
      dataField: "answer",
      text: "Answer",
    },
    {
      dataField: "display_order",
      text: "Display Order",
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cellContent, row) => (
        <>{row?.status == "1" ? "Active" : "In Active"}</>
      ),
    },
    {
      dataField: "createdAt",
      text: "Created On",
      formatter: cell => {
        return moment(getCompanyTimezoneDateTime(cell))?.format("DD MMM YYYY");
      },
    },
    {
      dataField: "updatedAt",
      text: "Updated On",
      formatter: cell => {
        return moment(getCompanyTimezoneDateTime(cell))?.format("DD MMM YYYY");
      },
    },
    {
      dataField: "",
      text: "Actions",
      formatter: (cell, row) => {
        let faqsId = row.id;
        return (
          <div className="d-flex gap-1">
            <Link
              className="text-success"
              to={`/faqs-edit/${row.id}`}
              title="Edit Faqs"
            >
              <i
                className="mdi mdi-pencil-outline font-size-18"
                id="logintooltip"
                style={{ color: "black" }}
              ></i>
            </Link>
            <div
              onClick={() => handleDeleteRecords(faqsId)}
              className="text-success"
              style={{ cursor: "pointer" }}
              to="#"
              title="Delete Blog"
            >
              <i
                className="mdi mdi-trash-can font-size-18"
                style={{ color: "black" }}
              ></i>
            </div>
          </div>
        );
      },
    },
  ];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing rows {from} to {to} of {size}
    </span>
  );

  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  // Delete Faqs
  const handleDeleteRecords = faqId => {
    console.log("deleting id:::", faqId);
    DeleteFaqsRecord(faqId)
      .then(res => {
        console.log("response", res.status);
        if (res.status == 200) {
          let messages = toast.success("Record deleted successfully.");
          window.location.reload();
        } else {
          toast.error(res?.data?.message);
          ref.current?.scrollIntoView({ behavior: "smooth" });
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  ///////////
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Row className="mb-3">
            <Col sm="6">
              <h5 className="text-uppercase">Faqs List </h5>
            </Col>

            <Col
              sm="6"
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Link to="/faqs-create" className="btn btn-primary">
                Create Faqs
              </Link>
            </Col>
          </Row>
          {successMessage && (
            <div class="alert alert-success" role="alert">
              {successMessage}
            </div>
          )}

          <Row>
            <ToolkitProvider
              keyField="head1"
              data={faqsData}
              columns={columns}
              search
            >
              {props => (
                <div>
                  <BootstrapTable
                    {...props.baseProps}
                    pagination={paginationFactory()}
                    options={options}
                    striped
                    hover
                  />
                </div>
              )}
            </ToolkitProvider>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default FaqsList;
